import { Component, Inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth/auth.service';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-generate-ticket-modal',
  standalone: false,
  templateUrl: './generate-ticket-modal.component.html',
  styleUrl: './generate-ticket-modal.component.scss',
})
export class GenerateTicketModalComponent implements OnInit {
  form: FormGroup;
  isDarkMode!: boolean;

  isLoadingPrivileges: boolean = true;

  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean;

  showErrorMessages: boolean = false;

  ticketList: any[] = [];
  vehicleTypes: any[] = [];

  rememberMe: boolean;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateTicketModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

    this.getAllVehicleTypes();

    this.form.get('vehicleTypeId')?.valueChanges.subscribe((id) => {
      const vehicle = this.vehicleTypes.find((v) => v.id === id);
      this.form.patchValue({ vehicleTypeName: vehicle ? vehicle.name : '' });
    });

    this.rememberMe = false;
  }

  initForm(): void {
    this.form = this.fb.group({
      vehicleTypeId: ['', [Validators.required]],
      vehicleTypeName: ['', [Validators.required]],
      numberOfTickets: ['', [Validators.required]],
    });
  }

  getAllVehicleTypes() {
    this.isLoading = true;
    this.apiService
      .get('/vehicle-type/all')
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((response: any) => {
        this.vehicleTypes = response.data.map((vehicleType) => ({
          ...vehicleType,
          formattedName: this.toTitleCase(vehicleType.name.replace(/_/g, ' ')),
        }));
      });
  }

  toTitleCase(str: string): string {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }


  closeModal(): void {
    if (!this.isSubmitting) {
      this.dialogRef.close();
    }
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload();
    });
  }

  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openConfirmModal() {
    let dialogRef = this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Generate Tickets?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.generateTickets();
        },
        onCancel: () => {
          // dialogRef.close()
        },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }

  addToTicketList(): void {
    if (this.form.valid) {
      this.ticketList.push(this.form.value);
      this.form.reset();
      this.showErrorMessages = false

    } else {
      this.showErrorMessages = true
    }
  }

  removeTicket(index: number): void {
    this.ticketList.splice(index, 1);
  }

  generateTickets(): void {
    this.isSubmitting = true;
    this.form.disable();

    const request = {
      requests: this.ticketList,
    };

    this.apiService
      .post('/ticket-batch/generate', request)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
          this.form.enable()
        })
      )
      .subscribe(
        (response: any) => {
          this.openSuccessModal(response?.message);

          this.dialogRef.close();
        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );

    this.isSubmitAttempted = true;
  }
}
